import { Amplify, API, Auth } from 'aws-amplify';

import CONFIG from './config';
const options = {
  ClientId: CONFIG.CLIENT_ID,
  Auth: {
    region: CONFIG.REGION,
    identityPoolId: CONFIG.IDENTITY_POOL_ID,
    userPoolId: CONFIG.USER_POOL_ID,
    userPoolWebClientId: CONFIG.CLIENT_ID,
  },
  API: {
    endpoints: [
      {
        name: CONFIG.ALICE_API,
        endpoint: CONFIG.BASE_URL,
        region: CONFIG.REGION,
      },
    ],
  },
};

Amplify.configure(options);

export default { Auth, API };
